import { render, staticRenderFns } from "./Quarentena.vue?vue&type=template&id=0a48fcf4&scoped=true"
import script from "./Quarentena.vue?vue&type=script&lang=js"
export * from "./Quarentena.vue?vue&type=script&lang=js"
import style0 from "./Quarentena.vue?vue&type=style&index=0&id=0a48fcf4&prod&scoped=true&lang=css"
import style1 from "./Quarentena.vue?vue&type=style&index=1&id=0a48fcf4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a48fcf4",
  null
  
)

export default component.exports